module.exports = __webpack_public_path__ + "static/media/Spoonerism-MT-TRAIL1.f931c3e7.mp3";